import { openNotification } from 'components/notification';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { Block } from '../GridDndEditor/models/Block.model';
import { GridBlockType } from 'services/entities/BlockTypes';
import { gridDefaultGreaterZAxis, gridDefaultHeight, gridDefaultWidth, gridDefaultXAxis, gridDefaultYAxis } from '../shared/gridConfig';
import { useAddSectionHandler } from '../hooks/useAddSectionHandler.ts';
import { useBlockAddedHandlerWithoutUndoRedo } from '../hooks/useNewBlockAddedHandler.ts';

type UseAddBlankSectionProps = {
  sectionId: string;
};

export function useAddBlankSection({ sectionId }: UseAddBlankSectionProps) {
  const { t } = useTranslation();
  const blockNewAddedHandler = useBlockAddedHandlerWithoutUndoRedo();
  const addNewSection = useAddSectionHandler();

  return useCallback(async () => {
    try {
      const { addedSectionId } = await addNewSection({
        title: t('editor.default_content_section_title'),
        afterSectionId: sectionId,
      });

      const blockConfig: Block = {
        width: gridDefaultWidth,
        height: gridDefaultHeight,
        x: gridDefaultXAxis,
        y: gridDefaultYAxis,
        z: gridDefaultGreaterZAxis,
      };

      await blockNewAddedHandler(addedSectionId, { htmlContent: '' }, blockConfig, GridBlockType.TEXT);
    } catch {
      openNotification({
        title: t('error'),
        description: t('editor.sections.add_blank_section_error'),
        type: 'error',
      });
    }
  }, [sectionId, t, blockNewAddedHandler, addNewSection]);
}
